import BaseBreadcrumb from "./BaseBreadcrumb";

export default BaseBreadcrumb;
